export default "__VITE_ASSET__C1V$o43O__"